function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "#D34B18",
  fillOpacity: 0.15
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6502 22.0002C10.462 22.0002 10.2751 21.919 10.1469 21.7615C9.91963 21.4835 9.96057 21.0741 10.2386 20.8468L21.9387 11.2799C22.2161 11.0524 22.6264 11.0933 22.8531 11.3716C23.0803 11.6494 23.0394 12.0588 22.7613 12.286L11.0613 21.8536C10.9407 21.952 10.795 22.0002 10.6502 22.0002Z",
  fill: "#D34B18"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7498 21.9999C19.6603 21.9999 19.5705 21.9815 19.4861 21.9441L15.4724 20.1623C15.1442 20.0163 14.9963 19.6323 15.142 19.3047C15.288 18.9765 15.6733 18.8286 15.9999 18.974L19.0998 20.3502V16.2159C19.0998 15.857 19.3909 15.5659 19.7498 15.5659C20.1088 15.5659 20.3998 15.857 20.3998 16.2159V21.3499C20.3998 21.5702 20.2884 21.7752 20.104 21.8952C19.9971 21.9644 19.8736 21.9999 19.7498 21.9999Z",
  fill: "#D34B18"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8521 19.3817C13.7639 19.3817 13.6744 19.3639 13.5887 19.3259L12.7416 18.9494H10.65C10.291 18.9494 10 18.6587 10 18.2994V12.7008C10 12.3418 10.291 12.0508 10.65 12.0508H12.7416L19.4863 9.05592C19.6878 8.96642 19.9202 8.98546 20.1043 9.10511C20.2887 9.22509 20.4001 9.43012 20.4001 9.65006V13.909C20.4001 14.268 20.109 14.5591 19.7501 14.5591C19.3911 14.5591 19.1001 14.268 19.1001 13.909V10.6498L13.1431 13.2949C13.0599 13.3317 12.9701 13.3508 12.8793 13.3508H11.3V17.6494H12.8793C12.9701 17.6494 13.0602 17.6685 13.1431 17.7053L14.1162 18.1376C14.4443 18.2836 14.5922 18.6676 14.4466 18.9958C14.339 19.2376 14.1012 19.3817 13.8521 19.3817Z",
  fill: "#D34B18"
});

var SvgMuted = function SvgMuted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMuted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/muted.afeb3d74.svg";
export { ForwardRef as ReactComponent };